export default "__VITE_ASSET__CDvKjXrk__"